<template>
  <v-form ref="form_default" data-vv-scope="form_default">
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs12 sm12 md12>
          <v-text-field
            class="required"
            prepend-icon="fa fa-credit-card-alt"
            disabled
            :value="numberMask"
            :label="$t('message.number')"
            data-vv-name="credit_card.number"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field
            class="required"
            prepend-icon="fa fa-eye-slash"
            return-masked-value
            mask="####"
            v-model="credit_card.security_code"
            v-validate="'required|min:3'"
            :error-messages="errors.collect('credit_card.security_code')"
            :label="$t('message.security_code')"
            data-vv-name="credit_card.security_code"
            data-vv-validate-on="blur"
            required
          >
            <template slot="append-outer" name="full_name_slot">
              <v-icon
                v-show="credit_card.security_code===undefined?true:(credit_card.security_code.length>0?false:true)"
              >fa fa-asterisk</v-icon>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field
            class="required"
            prepend-icon="fa fa-calendar"
            disabled
            return-masked-value
            mask="####/##"
            placeholder="YYYY/MM"
            v-model="valueCreditCard.expirationDate"
            :label="$t('message.expiration_date')"
            data-vv-name="credit_card.expiration_date"
          >
       
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { EventBus } from "./EventBus.js";

export default {
  data() {
    return {
      icon_name: "",
      masks: {
        credit_card: "credit-card"
      },
      credit_card: {
        number: "",
        security_code: "",
        expiration_date: "",
        paymentMethod: ""
      }
    };
  },
  mounted() {
    this.$nextTick(function() {
      EventBus.$on("next", this.validateForm0);
      EventBus.$on("resetform_default", this.reset);
    });
  },
  computed: {
    numberMask() {
      return "*************" + this.valueCreditCard.number;
    }
  },
  props: {
    valueCreditCard: {
      type: Object,
      default: function() {
        return { paymentMethod: "card" };
      }
    }
  },
  methods: {
    validateForm0(scope) {
      console.log("scope >>>>>>>>>>>" + scope);
      if (scope == "form_default") {
        this.$validator.validateAll(scope).then(res => {
            console.log(res);
          if (res) {
            this.$parent.$emit("submit", {
              valueCreditCard: this.valueCreditCard,
              security_code: this.credit_card.security_code,
              form: scope
            });
          }
        });
      }
    },
    reset() {
      if (this.$refs.form_default !== undefined) {
        console.log("credit card defined");
        this.credit_card.security_code = "";
      }
    }
  }
};
</script>